import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/store/store";
import {
  selectLoaders,
  selectLoadersLoading,
  selectIsAuth,
  selectNullableApplicationId,
} from "@/store/selectors";
import { loadLoadersThunk } from "@/server/thunks/loadersThunk";

export const useLoaders = () => {
  const dispatch = useAppDispatch();
  const loaders = useAppSelector(selectLoaders);
  const loading = useAppSelector(selectLoadersLoading);
  const applicationId = useAppSelector(selectNullableApplicationId);
  const isAuth = useAppSelector(selectIsAuth);

  useEffect(() => {
    if (!loaders.length && !loading && isAuth && applicationId) {
      dispatch(loadLoadersThunk());
    }
  }, [isAuth, applicationId]);
};
